'use strict';
angular
    .module('MW.ContactManager.ContactManagerPropertyTypeService', [])
    .factory('emailTypes', ['FairhairAddressTypes', function(FairhairAddressTypes) {
        return {
            PERSONAL: FairhairAddressTypes.PERSONAL,
            WORK: FairhairAddressTypes.WORK,
            OTHER: FairhairAddressTypes.OTHER
        };
    }])
    .factory('phoneNumberTypes', ['FairhairAddressTypes', function(FairhairAddressTypes) {
        return {
            MOBILE: FairhairAddressTypes.MOBILE,
            HOME: FairhairAddressTypes.HOME,
            WORK: FairhairAddressTypes.WORK,
            FAX: FairhairAddressTypes.FAX,
            OTHER: FairhairAddressTypes.OTHER
        };
    }])
    .factory('addressTypes', ['FairhairAddressTypes', function(FairhairAddressTypes) {
        return {
            HOME: FairhairAddressTypes.HOME,
            WORK: FairhairAddressTypes.WORK,
            OTHER: FairhairAddressTypes.OTHER
        };
    }])
    .value('salutationTypes', {
        MR: 'Mr',
        MS: 'Ms',
        HERR: 'Herr',
        FRAU: 'Frau',
        DR: 'Dr',
        PROF: 'Prof'
    })
    .value('activeOnTypes', {
        TWITTER: 'Twitter',
        FACEBOOK: 'Facebook',
        LINKED_IN: 'LinkedIn',
        BLOG: 'Blog',
        SOURCE: 'Source'
    })
    .value('activeOnUrls', {
        TWITTER: 'https://www.twitter.com/',
        FACEBOOK: 'https://www.facebook.com/'
    })
    .value('activeOnUrlPartials', {
        LINKEDIN: 'linkedin.com'
    })
    .constant('FairhairAddressTypes', {
        PERSONAL                        : 'personal',
        WORK                            : 'work',
        HOME                            : 'home',
        MOBILE                          : 'mobile',
        FAX                             : 'fax',
        OTHER                           : 'other'
    })
    .constant('FairhairChannelTypes', {
        WEBSITE                         : 'website',
        SOURCE                          : 'source',
        SOCIAL                          : 'social'
    })
    .constant('FairhairSocialProfileTypes', {
        FACEBOOK                        : 'facebook',
        TWITTER                         : 'twitter',
        LINKED_IN                       : 'linked_in',
        XING                            : 'xing'
    })
    .constant('Meridiem', {
        AM                              : 'AM',
        PM                              : 'PM'
    });
